mutation TravelAuthorizationRowProtection(
  $input: TravelAuthorizationRowProtectionInput!
) {
  travelAuthorizationRowProtection(input: $input) {
    secureRowLevel {
      id
      name
    }
  }
}
